import { IMAGES } from '../mock';

export default function Footer() {
  return (
    <footer className="bg-[#0d281e] text-[#f1ede5] pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <img
              src={IMAGES.logo}
              alt="Valley Mills · Pudsey · Leeds"
              className="w-[280px] h-auto"
              style={{ mixBlendMode: 'lighten' }}
            />
            <p className="mt-8 text-[13px] leading-[1.8] text-[#f1ede5]/70 max-w-sm">
              Premium trade counter, industrial and office space in a landmark refurbished Yorkshire
              mill. Work. Create. Grow.
            </p>
          </div>

          <div>
            <span className="eyebrow">Explore</span>
            <ul className="mt-6 space-y-3">
              {['The Development', 'Location', 'Trade & Industrial', 'Office Suites', 'Availability', 'Enquire'].map((l) => (
                <li key={l}>
                  <a href="#top" className="text-[13px] text-[#f1ede5]/80 hover:text-[#b39352] transition-colors">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <span className="eyebrow">Contact</span>
            <div className="mt-6 font-serif-display text-[20px] leading-[1.5] text-[#f1ede5]">
              151 Kent Road<br />Pudsey, Leeds<br />LS28 9NF
            </div>
            <div className="mt-6 space-y-2 text-[13px] text-[#f1ede5]/80">
              <div><a href="tel:01138474474" className="hover:text-[#b39352] transition-colors">0113 847 4474</a></div>
              <div><a href="mailto:sales@valleymills.co.uk" className="hover:text-[#b39352] transition-colors">sales@valleymills.co.uk</a></div>
              <div><span className="text-[#f1ede5]/60">valleymills.co.uk</span></div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#f1ede5]/12 flex items-center justify-between flex-wrap gap-3">
          <div className="text-[10px] tracking-[0.2em] text-[#f1ede5]/50">
            © 2026 VALLEY MILLS. ALL RIGHTS RESERVED.
          </div>
          <div className="text-[10px] tracking-[0.3em] text-[#b39352]">
            WORK · CREATE · GROW
          </div>
        </div>
      </div>
    </footer>
  );
}
